import { useQuery, useQueryClient } from "@tanstack/react-query";
import classNames from "classnames";
import LabelledDivRow from "components/LabelledDivRow";
import { Loading } from "components/panels";
import React from "react";

const GeocodeRows = () => {
  const healthQuery = useQuery({
    queryFn: async () => window.CoreApi.Diagnostic.GeoCodeHealth().then(r => r.data),
    queryKey: ["geocodeHealth"]
  });

  const queryClient = useQueryClient();

  const onRefresh = async () => queryClient.invalidateQueries(["geocodeHealth"]);

  if (healthQuery.isError) return <div>Error loading geocode health</div>;
  if (healthQuery.isFetching) return <Loading />;

  const { lookupPending, lookupPendingKey, otherException, otherExceptionKey, googleFoundNoGeoLocation, googleFoundNoGeoLocationKey } = healthQuery.data;
  const getKey = (key: number) => `key: ${key}`;
  return <>
    <LabelledDivRow label="Lookup pending" title={getKey(lookupPendingKey)}>
      <div className={classNames({ red: lookupPending > 10 })}>{lookupPending}</div>
    </LabelledDivRow>
    <LabelledDivRow label="Other exception" title={getKey(otherExceptionKey)}>
      <div className="red">{otherException}</div>
    </LabelledDivRow>
    <LabelledDivRow label="NoGeoLocationFound" title={getKey(googleFoundNoGeoLocationKey)}>
      <div>{googleFoundNoGeoLocation}</div>
    </LabelledDivRow>
    <LabelledDivRow label="">
      <a onClick={onRefresh}>Refresh</a>
    </LabelledDivRow>
  </>;
};

export default GeocodeRows;